<template>
  <el-dialog title="选择发票金额" :visible.sync="dialogVisible" width="760px" :close-on-click-modal="false" :close-on-press-escape="false" custom-class="select-invoice-dlg" @close="close">
    <el-table :data="rechargeRecords" border size="small" ref="rechargeRef" @selection-change="selectRechargeChange" :max-height="500">
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column :label="col.name" :prop="col.key" v-for="col in rechargeColumns" :key="col.key"></el-table-column>
    </el-table>
    <el-table :data="deductRecords" border size="small" ref="deductRef" :header-cell-class-name="headerClass" @selection-change="selectDeductChange" :max-height="500">
      <el-table-column type="selection" width="50">
        <template slot-scope="scope">
          <el-checkbox v-model="deductDisabled" :disabled="true"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column :label="col.name" :prop="col.key" v-for="col in deductColumns" :key="col.key"></el-table-column>
    </el-table>
    <div slot="footer" class="dialog-footer">
      <div class="invoice-desc">
        <label>发票备注:</label>
        <el-input v-model="desc" size="small"></el-input>
      </div>
      <div>
        <span>发票金额：<span class="main-text">{{invoiceAmount | formatNum('.2')}}</span></span>
        <el-button type="primary" size="small" :disabled="invoiceAmount <= 0" @click="select">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
  import {DateUtils, numUtils} from 'common/utils.js';
  import math from 'common/math.js';
  export default {
    name: 'select-invoice',
    props: {
      visible: Boolean,
      recordIds: {
        type: Array,
        default() {
          return [];
        }
      },
      rechargeRecords: {
        type: Array,
        default() {
          return [];
        }
      },
      deductRecords: {
        type: Array,
        default() {
          return [];
        }
      },
      rechargeColumns:  {
        type: Array,
        default() {
          return [];
        }
      },
      deductColumns: {
        type: Array,
        default() {
          return [];
        }
      }
    },
    data() {
      return {
        desc: '',
        dialogVisible: false,
        // deductRecords: [],
        rechargeSelected: [],
        deductSelected: [],
        deductDisabled: true
      }
    },
    computed: {
      invoiceAmount() {
        const recharge = this.rechargeSelected.reduce((a, b) => {
          return a + +b.amount;
        }, 0);
        const deduct = this.deductSelected.reduce((a, b) => {
          return a + +b.amount;
        }, 0);
        return math.add(recharge, deduct);
      }
    },
    watch: {
      visible(v) {
        this.dialogVisible = v;
        if (v) {
          this.setRecords()
        }
      }
    },
    filters: {
      formatNum: numUtils.formatNum
    },
    methods: {
      close() {
        this.$emit('changeVisible', false);
      },
      dateFormat(row, column) {
        return DateUtils.format(row[column.property], 'yyyy-MM-dd HH:mm');
      },
      selectRechargeChange(data) {
        this.rechargeSelected = data;
      },
      selectDeductChange(data) {
        this.deductSelected = data;
      },
      select() {
        if (this.invoiceAmount <= 0) return;
        const data = {
          invoiceDesc: this.desc.trim(),
          invoiceAmount: this.invoiceAmount,
          recordIds: this.rechargeSelected.map(it => it.recordId),
          deductIds: this.deductSelected.map(it => it.recordId)
        };
        this.$emit('changeVisible', false, data);
      },
      setRecords() {
        this.deductSelected = this.deductRecords;
        this.$nextTick(() => {
          if (!this.recordIds || !this.recordIds.length) {
            this.$refs.rechargeRef.toggleAllSelection();
          } else {
            this.rechargeRecords.forEach(it => {
              if (this.recordIds.includes(it.recordId)) {
                this.$refs.rechargeRef.toggleRowSelection(it, true);
              } else {
                this.$refs.rechargeRef.toggleRowSelection(it, false);
              }
            });
          }
        });
      },
      headerClass({columnIndex}) {
        if (columnIndex == 0) {
          return 'check-header';
        }
        return '';
      }
    }
  }
</script>
<style lang="scss">
  .select-invoice-dlg {
    .dialog-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-input {
        width: 300px;
      }
    }
    th.el-table__cell.check-header .cell {
      display: none;
    }
    .el-table {
      margin-bottom: 10px;
    }
  }
</style>